export const STORE_QUERY_PARAMS = ['utm_source', 'utm_campaign', 'utm_medium', 'utm_term', 'via']
